angular.module('jv.search.linkedin-profile-modal.directive', [])
.controller('jvLinkedinProfileModalController', [
    '$scope', '$sce', '$window', '$timeout', function($scope, $sce, $window) {
    }
])
.directive('jvLinkedinProfileModal', [
    '$window','$sce',
    function($window, $sce) {
        return {
            scope: {
                obj : '=',
                index: '=',
                ngShow: '='
            },
            controller: 'jvLinkedinProfileModalController',
            templateUrl: 'modals/linkedinProfileModal.html',
            link: function($scope, element, attrs) {
                $scope.getLinkedInProfileData = function(index, applicationData) {
                    var liHWURL = $window.jvUrls.jhire + '/action/application/' + applicationData.EId + '/linkedInApplyConnect/LIHWFrame.html';
                    $scope.liHWFrameurl = $sce.trustAsResourceUrl(liHWURL);
                };
                if($scope.ngShow) {
                    $scope.getLinkedInProfileData($scope.index, $scope.obj);
                }
            }
        };
    }
]);